import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { api, formatApiError, formatRupiah } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, ForkKnife } from "@phosphor-icons/react";

export default function MenuOrders() {
  const { id } = useParams();
  const [menu, setMenu] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get(`/menus/${id}`),
      api.get(`/menus/${id}/orders`),
    ]).then(([m, o]) => {
      setMenu(m.data);
      setOrders(o.data);
    }).catch(e => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="min-h-screen bg-[#FDFBF7]"><Navbar /><p className="p-12 font-display text-2xl">Memuat…</p></div>;

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-10">
        <Link to="/dashboard" className="inline-flex items-center gap-2 font-bold" data-testid="orders-back-link"><ArrowLeft size={18} weight="bold" /> Kembali</Link>
        <span className="nb-badge mt-6 inline-block" style={{ background: "#FFD166" }}>Pesanan</span>
        <h1 className="font-display font-black text-4xl tracking-tight mt-3">{menu?.name}</h1>
        <p className="text-[#4A4A4A] mt-1">Total {orders.length} pesanan</p>

        {orders.length === 0 ? (
          <div className="nb-card mt-8 p-10 text-center">
            <ForkKnife size={48} weight="bold" className="mx-auto" />
            <h3 className="font-display font-black text-2xl mt-3">Belum ada pesanan</h3>
            <p className="text-[#4A4A4A] mt-2">Bagikan link <span className="mono">/m/{menu?.slug}</span> atau cetak sebagai QR di meja.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 gap-4 mt-6">
            {orders.map(o => (
              <div key={o.id} className="nb-card p-5" data-testid={`order-card-${o.id}`}>
                <div className="flex justify-between items-start">
                  <div>
                    <div className="font-display font-black text-xl">
                      {menu?.require_table && o.table_number ? `Meja ${o.table_number}` : "Pesanan"}
                    </div>
                    {o.customer_name && <div className="text-sm text-[#4A4A4A]">oleh {o.customer_name}</div>}
                  </div>
                  <span className="mono text-xs text-[#4A4A4A]">{new Date(o.created_at).toLocaleString("id-ID")}</span>
                </div>
                <div className="mt-3 space-y-1">
                  {o.items?.map((it, i) => (
                    <div key={i} className="flex justify-between text-sm">
                      <span>{it.qty}× {it.name}</span>
                      <span className="mono">{formatRupiah(it.qty * it.price)}</span>
                    </div>
                  ))}
                </div>
                <div className="flex justify-between font-bold mt-3 pt-2 border-t border-[#121212]/20">
                  <span>Total</span>
                  <span className="mono">{formatRupiah(o.total)}</span>
                </div>
                {o.notes && <p className="text-xs text-[#4A4A4A] mt-2 italic">&ldquo;{o.notes}&rdquo;</p>}
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
